import * as cheerio from 'cheerio';

// eslint-disable-next-line import/no-cycle
import {
  getSmartListHtmlELementFromState,
} from '@/composables/template-editor/TemplateEditor';

import { Maybe } from '@/types/generated-types/graphql';

// eslint-disable-next-line import/no-cycle
import {
  getTemplateIframeDocument,
} from '../utils/helpers';

const getContent = (selector: string, name: string, widgetId: string) => {
  const template = getTemplateIframeDocument();
  const element: HTMLElement|null = template?.querySelector(selector);

  if (element) {
    // This getter can be involved by translation
    const content: Maybe<string> = getSmartListHtmlELementFromState(widgetId);

    if (content) {
      // Nettoyer le contenu avec cheerio pour supprimer les boutons d'actions
      const $ = cheerio.load(content);
      $('#widget-actions-buttons-group').remove();
      $('[id^="widget-"][id$="-button-identifier"]').remove();
      return $('body').html() || content;
    }

    // Nettoyer le contenu HTML de l'élément
    const $ = cheerio.load(element.innerHTML);
    $('#widget-actions-buttons-group').remove();
    $('[id^="widget-"][id$="-button-identifier"]').remove();
    return $('body').html() || element.innerHTML;
  }
  return undefined;
};

export default getContent;
